module.exports = __webpack_public_path__ + "img/profile-dropdown.ec948c58.png";